import { useSelector } from 'react-redux'
import { useProductionByRoute } from './useProductionByRoute'
import { getModeledProductions, sortByPoints } from 'selectors'

const fixtures = []

interface useProductionsInterface {
  imported: any[];
  fixtures: any[];
}

const useProductions = (): useProductionsInterface => {
  const imported: any[] = useSelector(getModeledProductions)

  return { imported, fixtures }
}

function extractProductionStyling(production) {
  const color = production?.color?.length > 0 ? production.color : production?.show?.color || production?.brands?.[0]?.color
  const backgroundColor = production?.backgroundColor?.length > 0 ? production?.backgroundColor : production?.backgroundColor?.backgroundColor || production?.brands?.[0]?.backgroundColor

  return {
    backgroundColor,
    color,
  }
}

export function extractStarNames(production) {
  let result = production?.segments?.reduce((prev, curr) => {
    const items = curr?.appearances?.reduce((appPrev, appCurr) => {
      return [...appPrev, appCurr.wrestler]
    }, [])
    return [...prev, ...items ]
  }, [])
    .sort(sortByPoints)

  result = [...new Map(result?.map(item => [item['id'], item])).values()]

  result = result?.map(item => item.name)

  return result?.splice(0, 5) || []
}

function useProductionStylingByRoute() {
  const production = useProductionByRoute()

  return extractProductionStyling(production)
}

export { useProductions, useProductionByRoute, useProductionStylingByRoute, extractProductionStyling }
